import QRious from 'qrious';
import GoogleAuthenticationForm from './google-authentication.form';
import { showModal, hideModal } from '@shared/ui/modal.util';

class GoogleAuthenticationController {
  constructor($timeout, CustomerApiService, SessionService, $scope, $state, EventDispatcherService) {
    'ngInject';

    this.$timeout = $timeout;
    this.CustomerApiService = CustomerApiService;
    this.SessionService = SessionService;

    this.secret = '';
    this.form = null;
    this.session = null;
    this.isSwitcheryChecked = false;
    this.backupCodes = [];
    this.$scope = $scope;
    this.$state = $state;
    this.EventDispatcherService = EventDispatcherService;

    this.$scope.$on('checkGoogleAuthStatus', () => {
      this.refreshToCheckGauthStatus();
    });
  }

$onInit() {
    this.session = this.SessionService.getSession();
    this.isSwitcheryChecked = this.session.isUsingGoogleTwoFactor;
    this.setupTabs();
    this.form = new GoogleAuthenticationForm();
  }

  setupTabs() {
    this.toggleView();
    this.$timeout (() => {
      $('a[data-toggle="tab"]').on('show.bs.tab', function(e) {
        let $target = $(e.target);
        if ($target.parent().hasClass('disabled')) {
          return false;
        }
      });

      let nextTab = (elem) => {
        let next = $(elem).next();
        next.find('a[data-toggle="tab"]').click();
        if (next[0].firstElementChild.id === 'step-2') {
          this.loadGoogleAuthenticationQRCode();
        }
      };

      function prevTab(elem) {
        let prev = $(elem).prev();
        prev.find('a[data-toggle="tab"]').click();
      }

      $('.next-step').click(function() {
        let $active = $('.g-auth .nav-tabs li.active');
        $active.next().removeClass('disabled');
        nextTab($active);

        $('#step-1, #step-2').parent().not('[class="active"]').addClass('done');
      });

      $('.prev-step').click(function() {
        let $active = $('.g-auth .nav-tabs li.active');
        prevTab($active);

        $('#step-1, #step-2, #step-3').parent().not('[class="done"]').removeClass('done');
      });

      let url = document.location.href;
      if ( (url.search('#transaction-pw')) > -1 ) {
        let n = $(document).height();
        $('html, body').animate({ scrollTop: n }, 100);
        $('#transaction-settings .trxn-settings > li:last-child, #transaction-settings .tab-content > #google-auth').removeClass('active');
        $('#transaction-settings .trxn-settings > li:first-child, #transaction-settings .tab-content > #transaction-pw').addClass('active');
      }
    });
  }

  onSwitch(state) {
    this.isSwitcheryChecked = state;
    
    if (this.session.hasTwoFactorEnabled) {
      this.switchGoogleTwoFactorAuthentication();
    }

    this.toggleView();
  }

  loadGoogleAuthenticationQRCode() {
    this.CustomerApiService.getGoogleAuthenticationCode().then((response) => {
      this.createQRCode(response.qr_code_link);
      this.form.secret = response.secret;
    });
  }

  switchGoogleTwoFactorAuthentication() {
    this.CustomerApiService.switchTwoFactor().then(() => {
      this.SessionService.set('isUsingGoogleTwoFactor', !this.session.isUsingGoogleTwoFactor);
      // Get the new modified session.
      this.session = this.SessionService.getSession();
    });
  }

  createQRCode(content) {
    const qr = new QRious({
      element: document.getElementById('qr'),
      size: 200,
      value: content,
    });
  }

  verify() {
    this.CustomerApiService.activateGoogleTwoFactor(this.form.toPayload()).then((response) => {
      this.SessionService.set('isUsingGoogleTwoFactor', true);
      this.SessionService.set('hasTwoFactorEnabled', true);
      this.session = this.SessionService.getSession();
      this.backupCodes = response.backup_codes;
      $('#gAuthSuccess').show();
      this.toggleView();
    }, (errors) => {
      this.form.setErrors(errors);
    });
  }

  /**
   * Hide / unhide GAuth Tab.
   */
  toggleView() {
    const shouldHideTab =  (this.session.hasTwoFactorEnabled) || (!this.isSwitcheryChecked);
    const element = document.getElementById('g-auth-tab');
    if (shouldHideTab) {
      element.classList.add('hidden');
    } else {
      element.classList.remove('hidden');
    }
  }

  resetGoogleAuth() {
    this.CustomerApiService.resetGoogleAuthenticationCode().then((response) => {
      if (response.status) {
        this.SessionService.set('hasTwoFactorEnabled', false);
        this.SessionService.set('isUsingGoogleTwoFactor', false);
        this.$scope.$emit('checkGoogleAuthStatus');
        this.$timeout(() => {
          showModal('successGoogleAuth')
        }, 500);
      }
    }).catch(() => {
      showModal('warningGoogleAuth');
    });
  }

  refreshToCheckGauthStatus() {
    this.$state.go(this.$state.current, {}, {reload: true, inherit: true});
  }
}

export default GoogleAuthenticationController;


// WEBPACK FOOTER //
// ./client/app/pages/settings/component/transaction-authentication/google-authentication/google-authentication.controller.js